import React, { useEffect, useRef } from 'react';
import { ParallaxLayer } from '../../../custom_modules/react-spring/src/renderprops/addons/index';
import useOnScreen from '../useOnScreen';
import './KSponsoredContent.scss';
import anime from 'animejs';
import LightBox from './LightBox';
import LightBox2 from './LightBox2';
import featured from '../assetsV2/featured';
import video1 from '../assetsV2/featured/auto1.mp4';
import video2 from '../assetsV2/featured/aotu2.mp4';

import videoCover1 from '../assetsV2/featured/covers/auto1.jpg';
import videoCover2 from '../assetsV2/featured/covers/aotu2.jpg';
import videoCover from '../assetsV2/videoCover';

const [cover1, cover2, cover3, cover4] = videoCover
const [
  viewWhite,
  likeWhite,
] = featured
console.log("videoCover", videoCover)

// import { fadeInTop, fadeInLeft, rotateIn } from './animations/allTransitions';
const twitchVideos = [{
  image: cover1,
  title: 'Ark: Survival Evolved',
  name: 'Loserfruit',
  views1: '181k',
  views2: '10k',
}, {
  image: cover2,
  title: 'PixARK',
  name: 'MrMEOLA',
  views1: '56k',
  views2: '1.7k',
}];

const youtubeVideos = [{
  image: cover3,
  title: 'Ark: Survival Evolved',
  name: 'Loserfruit',
  views1: '450k',
  views2: '9.4k',
  url: "https://www.twitch.tv/videos/2490174878?t=2h41m17s"

}, {
  image: cover4,
  title: 'PixARK',
  name: 'MrMEOLA',
  views1: '310k',
  views2: '7.3k',
  url: "https://www.twitch.tv/videos/2497454551?t=2h57m41s"
}];

const KSponsoredContent = (props) => {
  const { pOffset, layoutFactor = 1, offsetAdjust = 0 } = props;
  const ref = React.createRef();
  const onScreen = useOnScreen(ref, '100px', 0.5);

  const [open, setOpen] = React.useState(false);
  const [twitchOpen, setTwitchOpen] = React.useState(false);

  const [videoCode, setCode] = React.useState('');
  const [twitchVideoCode, setTwitchCode] = React.useState('');


  const [debounce, setDebounce] = React.useState(true);

  const youtubeUrlCodes = ['8hpXkniByp0', 'V8m9AMxMG6g'];
  const twitchUrlCodes = ['2490174878', '2497454551'];

  const video1Ref = useRef(null);
  const video2Ref = useRef(null);



  // 进入视口时加载视频，离开时移除
  useEffect(() => {
    if (onScreen) {
      if (video1Ref.current) video1Ref.current.play();
      if (video2Ref.current) video2Ref.current.play();
    } else {
      if (video1Ref.current) video1Ref.current.pause();
      if (video2Ref.current) video2Ref.current.pause();
    }
  }, [onScreen]);

  useEffect(() => {
    if (onScreen && debounce) {
      anime({
        targets: '.cascade-fade-k',
        opacity: [1, 0],
        translateY: 100,
        duration: 800,
        direction: 'reverse',
        easing: 'linear',
        delay: anime.stagger(200, { direction: 'reverse' }),
      });
      setDebounce(false);
    }
  }, [onScreen, debounce]);


  const handleOpenYoutube = (index) => {
    if (video1Ref.current) video1Ref.current.pause();
    if (video2Ref.current) video2Ref.current.pause();
    setCode(youtubeUrlCodes[index]);
    setOpen(true);
  };

  const handleOpenTwitch = (index) => {
    if (video1Ref.current) video1Ref.current.pause();
    if (video2Ref.current) video2Ref.current.pause();
    setTwitchCode(twitchUrlCodes[index]);
    setTwitchOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (video1Ref.current) video1Ref.current.play();
    if (video2Ref.current) video2Ref.current.play();
  };

  const handleTwitchClose = () => {
    setTwitchOpen(false);
    if (video1Ref.current) video1Ref.current.play();
    if (video2Ref.current) video2Ref.current.play();
  };



  return (
    < >
      <ParallaxLayer
        offset={pOffset + offsetAdjust}
        factor={layoutFactor} speed={0}
        className="slide-k-container hide-brand-scroll"
      >
        <div ref={ref} />
        <div className="brand-k-title cascade-fade-k fade-up-prep">
          FEATURED SPONSORED CONTENT
        </div>
        <div className='brand-k-content'>
          <div className="brand-k-content-item">
            <div className='brand-k-videos'>
              {twitchVideos.map((content, i) => (
                <div key={i} className="cascade-fade-k fade-up-prep">
                  <div className="featured-content-view">
                    <div className="image-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                      <img
                        src={content.image}
                        alt="alt"
                        onClick={() => handleOpenTwitch(i)}
                        className="image"
                        loading="lazy"
                      />
                      <div
                        className="play-btn"
                        onClick={() => handleOpenTwitch(i)}
                      />
                    </div>
                    <div className="stats" >
                      <div><img src={viewWhite} alt="view icon" loading="lazy" /> {content.views1}</div>
                      <div><img src={likeWhite} alt="like icon" loading="lazy" /> {content.views2}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <video
              ref={video1Ref}
              autoPlay
              className="big-image"
              src={video1}
              loop
              muted
              playsInline
              poster={videoCover1}
            />
            <LightBox2
              open={twitchOpen}
              src={`https://player.twitch.tv/?video=${twitchVideoCode}&parent=${window.location.hostname}`}
              handleClose={handleTwitchClose}
            />
          </div>
          <div className="brand-k-content-item">
            {/* <img src={loserFruitImage} alt="alt" className="big-image " /> */}
            <video
              ref={video2Ref}
              autoPlay
              className="big-image"
              src={video2}
              loop
              muted
              playsInline
              poster={videoCover2}
            />
            <div className='brand-k-videos2'>
              {youtubeVideos.map((content, i) => (
                <div key={i} className="cascade-fade-k fade-up-prep">
                  <div className="featured-content-view">
                    <div className="image-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                      <img
                        src={content.image}
                        alt="alt"
                        onClick={() => handleOpenYoutube(i)}
                        className="image"
                      />
                      <div
                        className="play-btn"
                        onClick={() => handleOpenYoutube(i)}
                      />
                    </div>
                    <div className="stats" >
                      <div><img src={viewWhite} alt="view icon" /> {content.views1}</div>
                      <div><img src={likeWhite} alt="like icon" /> {content.views2}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <LightBox open={open} src={`https://www.youtube.com/embed/${videoCode}`} handleClose={handleClose} />
          </div>
        </div>
      </ParallaxLayer>
    </>
  );
};


export default KSponsoredContent;

